<template>
  <div class="confirmation-upload-result">
    <div class="batch-upload-step-four">
      <div class="info-left-top-confirmation">
        <img v-if="confirmationExport.code == 200" src="@/assets/image/ic_success.png">
        <img v-else-if="isError" src="@/assets/image/失败.svg">
        <img v-else src="@/assets/image/batch-upload-dialog/ic_attend.png">
        <div class="info-left-tip">
          <div>
            <span class="span-text">{{ this.msg }}</span>
          </div>
          <div class="result-btn-div">
            <el-button v-if="confirmationExport.url && ['206'].includes(String(confirmationExport.code))"
                       class="btn-download" type="primary" plain @click="downLoadTemp">下载导入报告
            </el-button>
            <el-button class="btn-retry" type="primary" plain @click.stop="clickRetry">重新导入</el-button>
          </div>
        </div>
      </div>
      <template v-if="['200','206'].includes(String(confirmationExport.code)) && confirmationExport.details.length">
        <div class="bar"></div>
        <table>
          <tr v-for="(item, index) in confirmationExport.details" :key="index">
            <td style="padding-bottom: 36px">
              <span class="text-01">0{{ index + 1 }}</span><br>
              <span class="text-02">{{ typeName(item.type) }}</span>
            </td>
            <td>
              <span class="text-01"> 案件总数</span><br>
              <span class="text-03">{{ item.caseCount }}个案件</span>
            </td>
            <td>
              <span class="text-01">  <i class="el-icon-check" style="color: rgb(0, 158, 105)"></i>成功补录</span><br>
              <span class="text-03">{{ item.successCount }}个案件</span>
            </td>
            <td>
              <span class="text-01">  <i class="el-icon-check" style="color: rgb(226, 129, 3)"></i>部分成功</span><br>
              <span class="text-03">{{ item.partSuccessCount }}个案件</span>
            </td>
            <td>
              <span class="text-01">  <i class="el-icon-close" style="color: rgb(196, 47, 44)"></i>补录失败</span><br>
              <span class="text-03">{{ item.failCount }}个案件</span>
            </td>
          </tr>
        </table>
      </template>
    </div>
    <div class="batch-upload-step-four-bottom">
      <el-button @click="close">知道了</el-button>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: 'confirmation-upload-result',
  computed: {
    ...mapState({confirmationExport: state => state.longTask.confirmationExport}),
    msg() {
      switch (String(this.confirmationExport.code)) {
        case '200': return '导入完成';
        case '206': return '导入完成';
        default: return this.confirmationExport.msg || '导入失败';
      }
    },
    isError() {
      let result = false;
      for (let i = 0; i < this.confirmationExport.details.length; i++) {
        if (this.confirmationExport.details[i].failCount) {
          result = true;
          break;
        }
      }
      return result;
    },
  },
  beforeDestroy() {
    this.$bus.$emit('closeMaterialUploadResult');
  },
  methods: {

    typeName(type) {
      switch (String(type)) {
        case '1':
          return '自然人信息补填';
        case '2':
          return '法人/非法人补填';
        case '3':
          return '代理人信息补填';
      }
    },
    downLoadTemp() {
      const {url} = this.confirmationExport;
      this.$utils.downloadFile(url);
    },

    clickRetry() {
      this.$emit('clickRetry');
    },
    close() {
      this.$emit('close');
    }
  },

};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.confirmation-upload-result {
  .info-left-top-confirmation {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    height: 100%;

    > img {
      margin-right: 12px;
      width: 48px;
      height: 48px;
    }

    .info-left-tip {
      flex: 1;
      height: 48px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      .span-text {
        color: rgb(51, 51, 51);
        font-size: 16px;
      }
    }

    .result-btn-div {
      display: flex;
      align-items: center;

      .btn-retry {
        width: 147px;
        height: 36px;
      }

      .btn-download {
        margin-right: 8px;
        margin-top: 0;
        width: 147px;
        height: 36px;
      }
    }
  }

  .batch-upload-step-four-bottom {
    height: 60px;
    border-top: 1px solid rgb(232, 232, 232);
    background: rgb(248, 248, 248);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 24px;

    .el-button {
      height: 36px;
      width: 120px;
    }
  }
}

.batch-upload-step-four {
  table {
    width: 100%;
    text-align: left;

    td i {
      font-weight: bold;
      margin-right: 4px;
    }
  }

  .bar {
    margin: 36px 0;
    height: 1px;
    background: rgb(230, 230, 230);
  }

  .text-01 {
    line-height: 22px;
    font-size: 14px;
    color: #A6A6A6;
  }

  .text-02 {
    line-height: 22px;
    font-weight: bold;
    font-size: 14px;
    color: #333;
  }

  .text-03 {
    line-height: 22px;
    font-size: 14px;
    color: #333;
  }

  .info-right-inner {
    color: #666;
  }

  .info-right-tip {
    color: #333;
  }

}

</style>
